import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../api/api";
import api from "../api/api";
import { iAuthInterface } from "../interfaces";
import { UserIndexInterface, EmpresaInterface } from "../interfaces";

export const AuthContext = createContext<iAuthInterface | null>(null)

const initialFieldsError = {
    email: [],
    password: [],
}

const initialUser = {
    id: "",
    name: "",
    email: "",
    password: "",
    empresa_logada: 0,
    is_staff: false,
    is_superuser: 0,
    permissions: [],
    empresas: [],
    profiles: [],
    active: false,
}

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [user, setUser] = useState<string>('')
    const [userLogado, setUserLogado] = useState<UserIndexInterface>(initialUser);
    const navigate = useNavigate();
    const [errors, setErrors] = useState(initialFieldsError);
    const [showError, setShowError] = useState<boolean>(false);
    const [showMessageError, setShowMessageError] = useState<string>('');
    const [licenca, setLicenca] = useState<boolean>(true);
    const [empresa, setEmpresa] = useState<string>('');
    const [empresas, setEmpresas] = useState<EmpresaInterface[]>([]);

    const clearError = (field: any) => {
        setErrors({
            ...errors,
            [field]: ""
        });
    }

    const changeShowError = (show: boolean) => {
        setShowError(false);
    }

    useEffect(() => {
        const token = localStorage.getItem('token');
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const empresaLogada = localStorage.getItem('empresa');

        
        if (token) {
            api.get('user').then((res) => {
                setIsAuthenticated(true);
                setUser(user.user.name);
                setEmpresas(user.user.empresas);
                if (empresaLogada) {
                    setEmpresa(empresaLogada);
                } else {
                    setEmpresa(user.user.empresa_logada);
                }
                setUserLogado(user.user);
                navigate('/');
            }).catch((error) => {
                navigate('/login');
            });
        } else {
            navigate('/login');
        }
    }, []);

    function checkPermission(permission: string): boolean {
        return userLogado.permissions.filter((perm: string) => perm === permission).length > 0
    }

    const login = async (email: string, password: string) => {

        try {
            setErrors(initialFieldsError);



            return await axios.post(`${BASE_URL}login`, {
                email: email,
                password: password
            }).then((res) => {

                localStorage.setItem('token', res.data.token);
                localStorage.setItem('user', JSON.stringify(res.data));

                setEmpresas(res.data.user.empresas);
                setEmpresa(res.data.user.empresa_logada);
                setUser(res.data.user.name);
                setUserLogado(res.data.user);
                setIsAuthenticated(true);
                localStorage.setItem('empresa', res.data.user.empresa_logada);
                setLicenca(!res.data.user.tenant_vencido);
                navigate('/');
            }).catch((error) => {
                const errors = [401, 403];

                if (error.response.status === 422) {
                    setErrors(error.response.data)
                }
                if (errors.includes(error.response.status)) {
                    setShowError(true)
                    setShowMessageError(error.response.data.message)
                }
               
            });

        } catch (error) {
            navigate('/login');
        }
    };

    const changeEmpresa = (empresa: string): void => {
        setEmpresa(empresa);
        localStorage.setItem('empresa', empresa);

        navigate('/');
    }

    const logout = async () => {
        await api.post('logout', {}).then(() => {

            localStorage.removeItem('token');
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('empresa');
            setIsAuthenticated(false);
            navigate('/login');
        });
    };

    

    return (
        <AuthContext.Provider value={
            {
                setShowError,
                setShowMessageError,
                empresa,
                empresas,
                isAuthenticated,
                user,
                errors,
                showError,
                changeShowError,
                showMessageError,
                login,
                logout,
                changeEmpresa,
                userLogado,
                checkPermission,
                clearError,
                licenca,
                setLicenca
            }
        }>
            {children}
        </AuthContext.Provider>
    );
}
